export default {
  ja: {
    common: {
      loading: "読み込み中...",
      unit: "円",
      salesPeriod: "販売期間",
      validBetween: "利用期間",
      attention: "料金に関する注意",
      other: "その他のチケット情報",
      officialWebsite: "公式サイト",
      terms: "チケット規約・約款",
      aboutRefund: "払い戻しについて",
      agreeToTerms: "チケット規約に同意する",
      readit: "必ずお読みください",
      contact: "お問い合わせ",
      seller: "販売事業者",
      ticketName: "チケット名",
      ticketingInfoLabel: "購入情報",
      startDateLabel: "利用開始日",
      endDateLabel: "利用終了日",
      useButtonLabel: "利用する",
      cancelButtonLabel: "キャンセル",
      backButtonLabel: "戻る",
      priceLabel: "料金",
      passengers: "購入枚数",
      validPeriod: "有効期間",
      effectiveDays: "日間有効",
      Tickets: "チケット情報",
      number: "番号",
      notUsed: "未使用",
      notIssued: "未発行",
      currentTime: "現在時刻",
      fromStation: "発駅",
      feature: "の特徴",
      mai: "枚",
      availableplace: "利用できる場所",
      IntroductionOfMenu: "ご提供メニューの紹介",
      externalLink: "外部リンク",
      makesureNote: "必ずご確認ください。このチケットに関する諸注意",
      storesAndFacilities: "対象施設・店舗・エリア",
      kintetsuExpressURL:
        "https://www.ticket.kintetsu.co.jp/M/MZZ/MZZ20.do?op=pDisplayServiceMenu",
      accountDialog: {
        header: "アカウント設定が必要です",
        body: "アカウント画面より「サインイン」と「クレジットカードの設定」をお願いします。",
        button: "設定する",
      },
      cardRegistrationDialog: {
        header: "クレジットカード認証に失敗しました",
        body: "クレジットカード情報をご確認の上、再度お試しください。",
        button: "設定する",
      },
      serverErroDialog: {
        header: "エラーが発生しています",
        body: "申し訳ございませんが、ただいま予約システムがご利用できません。",
        button: "戻る",
      },
    },
    Errors: {
      cardAuthFailed: {
        header: "決済失敗",
        title: "クレジットカードの認証に失敗しました",
        description:
          "クレジットカードの利用承認が得られませんでした。カード情報をご確認の上、再度ご購入ください。",
        buttonLabel: "チケット詳細へ戻る",
      },
      unauthorizedAccount: {
        header: "アカウント設定が必要です",
        title: "アカウント設定が必要です",
        description:
          "アカウント画面より「サインイン」と「クレジットカードの設定」をお願いします。",
        buttonLabel: "設定する",
      },
      invalidPageAccess: {
        title: "ページが見つかりません",
        description: "チケットストアへ戻り再度アクセスしてください。",
        buttonLabel: "チケットストアへ",
      },
      reachedPurchaseLimit: {
        title: "購入画面へ移動できません",
        description: "このチケットをこれ以上所持することはできません。",
        buttonLabel: "閉じる",
      },
    },
    BookingMobility: {
      mobilityInfo: "モビリティ情報",
      company: "事業者",
      price: "料金",
      pleaseNote: "ご注意",
      other: "その他",
      officialSite: "公式サイト",
      terms: "利用規約",
      contact: "お問い合わせ",
      agreeToTerms: "利用規約に同意する",
      goToBooking: "予約手続きへ",
      goToBookingDetail: "予約内容を確認",
      checkingLogin: "登録情報を確認しています...",
    },
    BookingForm: {
      headLabel: "交通機関",
      leadMessage: "出発地と到着地を選択してください",
      leadNotes: "地図から選択することも可能です。",
      departureLabel: "出発地",
      departureLabelPlaceholder: "出発地を選択してください",
      arrivalLabel: "到着地",
      arrivalLabelPlaceholder: "到着地を選択してください",
      bookingInfoLabel: "予約情報",
      dateLabel: "希望日時",
      datetimeFor: {
        label: "出発 / 到着",
        depatureOption: "出発",
        arrivalOption: "到着",
      },
      datetimeError: "予約可能な日時は本日より7日後までです",
      datetimeErrorForDfp:
        "予約可能な日時は本日よりデジタルフリーパスの最短有効期間(%{date})までです",
      adultSeatCountLabel: "おとな",
      childSeatCountLabel: "こども",
      seatCountNotes: "※おとな（12歳以上）、こども（6〜12歳未満）",
      seatCountError: "予約できる人数は最大%{max}人までです",
      conditions: {
        label: "乗車条件",
        shareableOption: "相乗り優先",
        reservedOption: "貸切",
      },
      payBy: {
        label: "お支払い",
        creditOption: "アプリ決済",
        cashOption: "現地決済 or 紙の乗車券使用",
        dfpOption: "デジタルフリーパス",
      },
      representativeInfoLabel: "代表者情報",
      familyNameLabel: "姓",
      familyNamePlaceholder: "姓",
      firstNameLabel: "名",
      firstNamePlaceholder: "名",
      phoneLabel: "電話番号",
      phonePlaceholder: "ハイフンなしで入力して下さい",
      submitButtonLabel: "内容を確認",
      cancelButtonLabel: "戻る",
      creatingDemand: "仮予約の問い合わせをおこなっています...",
      createDemandErrorDialog: {
        overlap: {
          header: "前回の予約との時間が近すぎます",
          body: "時間を変更してお試しください。",
        },
        estimation: {
          header: "条件に合う車両がみつかりませんでした",
          body: "発着日時や人数を変更してお試しください。",
        },
        area: {
          header: "利用できない区間が含まれています",
          body: "運行系統が異なる区間で予約することはできません。",
        },
        other: {
          header: "エラーが発生しました",
          body: "時間をあけてお試しください。",
        },
        cancel: "内容を変更する",
      },
    },
    BookingConfirmation: {
      headLabel: "予約内容の確認",
      leadMessage: "予約内容をご確認ください",
      leadNotes: "※2分以内に予約を確定してください。",
      demandInfoHeaderLabel: "予約情報",
      mobilityLabel: "交通機関",
      priceLabel: "料金",
      price: "%{price} 円",
      dfpPrice: "デジタルフリーパス利用",
      payByLabel: "お支払い",
      datetimeLabel: "利用日時",
      dateTimeForDepature: "出発",
      travelTimeLabel: "所要時間",
      travelTimeValue: "約%{min}分",
      seatCountsLabel: "人数",
      seatCountsValue: "おとな&nbsp;%{adult}&emsp;子ども&nbsp%{child}",
      pickUpPositionLabel: "出発地",
      dropOffPositionLabel: "到着地",
      conditionsLabel: "乗車条件",
      representativeInfoHeaderLabel: "代表者情報",
      representativeName: "お名前",
      phoneLabel: "電話番号",
      approveButtonLabel: "予約を確定",
      cancelButtonLabel: "修正",
      decliningDemand: "仮予約のキャンセルを行っています...",
      payBy: {
        credit: "アプリ決済",
        cash: "現地決済 or 紙の乗車券使用",
        dfp: "デジタルフリーパス",
      },
      datetimeFor: {
        departure: "出発",
        arrival: "到着",
      },
      conditions: {
        shareable: "相乗り優先",
        reserved: "貸切",
      },
    },
    BookingArrangement: {
      demandCanceledDialog: {
        header: "予約が確定できませんでした",
        body: "時間内に予約が完了しなかったため、予約を確定できませんでした。",
        button: "予約をやり直す",
      },
      demandUpdatedDialog: {
        header: "予約を変更しました",
      },
      decliningDialog: {
        header: "仮予約のキャンセルを行っています...",
      },
      loadingMessage: {
        payment: "決済手続きの完了を待っています...",
        approveDemand: "車両を手配しています...",
        updateSeatCounts: "人数変更処理を行っています...",
        loading: "準備中...",
      },
    },
    BookingDetail: {
      countDownCard: {
        datetime: "利用日時",
        label: "お迎えまで",
        status: {
          pickingUp: "配車中",
          boarding: "乗車中",
          finished: "乗車後",
          canceled: "取消済",
        },
      },
      demandInfoHeaderLabel: "予約情報",
      mobilityLabel: "交通機関",
      orderId: "予約番号",
      priceLabel: "料金",
      price: "%{price} 円",
      dfpPrice: "デジタルフリーパス利用",
      sharedPrice: "相乗り料金",
      payByLabel: "お支払い",
      datetimeLabel: "利用日時",
      travelTimeLabel: "所要時間",
      travelTimeValue: "約%{min}分",
      seatCountsLabel: "人数",
      seatCountsValue: "おとな&nbsp;%{adult}&emsp;子ども&nbsp%{child}",
      pickUpPositionLabel: "出発地",
      dropOffPositionLabel: "到着地",
      conditionsLabel: "乗車条件",
      representativeInfoHeaderLabel: "代表者情報",
      representativeName: "お名前",
      phoneLabel: "電話番号",
      attention: "ご注意",
      updateButton: {
        active: "人数を変更",
        used: "利用済み",
        canceled: "取り消し済み",
      },
      cancelButton: {
        active: "予約を取り消す",
        used: "利用済み",
        canceled: "取り消し済み",
      },
      payBy: {
        credit: "アプリ決済",
        cash: "現地決済 or 紙の乗車券使用",
        dfp: "デジタルフリーパス",
      },
      datetimeFor: {
        departure: "出発",
        arrival: "到着",
      },
      conditions: {
        shareable: "相乗り優先",
        reserved: "貸切",
      },
      landmarkImageDialog: {
        button: "閉じる",
      },
      cancelDemandConfirmDialog: {
        header: "予約を取り消しますか？",
        body: "料金を支払い済みの場合、全額返金します。",
        submitButton: "取り消す",
        cancelButton: "戻る",
      },
      cancelingDemandDialog: {
        header: "予約をキャンセルしています...",
      },
      cancelDemandDoneDialog: {
        header: "予約を取り消しました",
      },
    },
    BookingUpdate: {
      headerTitle: "予約人数の変更",
      headLabel: "交通機関",
      bookingInfoLabel: "予約情報",
      adultSeatCountLabel: "おとな",
      childSeatCountLabel: "こども",
      seatCountNotes: "※おとな（12歳以上）、こども（6〜12歳未満）",
      seatCountError: "予約できる人数は最大%{max}人までです",
      submitButtonLabel: "内容を確認",
      cancelButtonLabel: "戻る",
      checkingUpdateDemandDialog: {
        header: "人数変更の可否を確認しています...",
      },
      updateDemandErrorDialog: {
        header: "予約が満席です",
        button: "チケット詳細へ戻る",
      },
    },
    BookingUpdateConfirmation: {
      headerTitle: "予約内容の確認",
      leadMessage: "予約内容をご確認ください",
      leadNotes: "※10分以内に予約を確定してください。",
      demandInfoHeaderLabel: "予約情報",
      mobilityLabel: "交通機関",
      priceLabel: "変更後料金",
      price: "%{price} 円",
      dfpPrice: "デジタルフリーパス利用",
      priceDiffLabel: "差額",
      payByLabel: "お支払い",
      datetimeLabel: "利用日時",
      departure: "出発",
      travelTimeLabel: "所要時間",
      travelTimeValue: "約%{min}分",
      seatCountsLabel: "人数",
      seatCountsValue: "おとな&nbsp;%{adult}&emsp;子ども&nbsp%{child}",
      pickUpPositionLabel: "出発地",
      dropOffPositionLabel: "到着地",
      conditionsLabel: "乗車条件",
      approveButtonLabel: "予約を確定",
      cancelButtonLabel: "修正",
      payBy: {
        credit: "アプリ決済",
        cash: "現地決済 or 紙の乗車券使用",
        dfp: "デジタルフリーパス",
      },
      datetimeFor: {
        departure: "出発",
        arrival: "到着",
      },
      conditions: {
        shareable: "相乗り優先",
        reserved: "貸切",
      },
    },
    BookingPaymentError: {
      errorDialog: {
        header: "エラーが発生しました",
        body: "支払い処理を中止しました。お手数おかけしますが、再度ご予約をお願いします。",
        button: {
          approve: "モビリティ情報へ戻る",
          update: "予約情報へ戻る",
        },
      },
      decliningDialog: {
        header: "仮予約のキャンセルを行っています...",
      },
    },
    // Ticketing
    TicketStoreTicketing: {
      // MasterBook
      ticketsIncluded: "含まれるチケット",
      buyRapidTrain: "特急券を購入",
      // BookBooking
      bookingHeader: "購入情報入力",
      goToBooking: "購入手続きへ",
      goToBookingConfirm: "チケット内容を確認",
      defaultStation: "乗車駅を選択してください",
      boardingStation: "乗車駅（任意）",
      cantSelectOutOfTerm: "※発売対象期間ではありません。",
      bookBookingDescription:
        "購入に必要な情報を入力して「チケット情報を確認」を押してください。",
      dateHelp: "1ヶ月先の日付まで選択できます",
      // BookBookingConfirmation
      bookBookingConfirmationTitle: "チケット確認",
      confirmAttention:
        "チケットの内容と諸注意をご確認の上、購入情報の入力にお進みください",
      confirmAttentionSub: "※10分以内に支払い手続きを完了してください",
      payByLabel: "購入情報の入力へ",
      modifyLabel: "修正",
      cautionOfSelectStationOdakyu:
        "※乗車券の区間は、発駅から小田原までの\n往復きっぷとなります",
      cautionOfSelectStationTanzawa:
        "※乗車券の区間は、発駅から［本厚木駅から渋沢駅］まで\nの往復きっぷとなります",
      cautionOfPayment_12:
        "悪天候等による運休で一部の乗り物をご利用できない場合でも、払いもどしはできません。ご了承ください。\n購入しますか？",
      cautionOfPayment_34:
        "購入した時点でサブスクリプションの１日目となります。開始日の変更や払いもどしはできません。\nサブスクリプションの解約は期間最終日の前々日までにお願いします。これを過ぎると期間が更新され、同時に課金も発生します。\n購入しますか？",
      // BookBookingResultダイアログ
      BookBookingResult: {
        header: "購入完了",
        title: "ご購入手続きが完了いたしました。",
        description:
          "ご購入いただいたチケットはホーム画面の「使う」からご確認、ご利用いただけます。",
        buttonLabel1: "特急券を購入",
        buttonLabel2: "チケットを確認する",
      },
    },
    MyTicketTicketing: {
      // Book
      refund: "払いもどす",
      refunded: "払い戻し済み",
      // BookRefund
      bookRefundTitle: "払い戻し",
      bookRefundDescription: "チケット情報と金額をご確認ください",
      refundLabal: "返金",
      refundAmount: "返金額",
      serviceCharge: "手数料",
      total: "合計",
      refundComplete: "払い戻しが完了しました",
      // Pass/Sheet
      attention: "この画面を係員にご提示ください",
      validUntil: "有効期間",
      made: "まで",
      ticketDetails: "チケット詳細へ",
      storesAndFacilities: "対象店舗・施設情報",
      entryThePasscode: "救済コード入力画面へ",
      UseTicket: "チケットを使う",
      UseStamp: "このスタンプを押す",
      QRReader: "チケットを使う",
      inputPasscode: "救済コードを入力してください",
      checkoutPoint: "チェック場所",
      checkoutDate: "チェック日時",
      // 払い戻し不可ダイアログ
      validBooks: {
        title: "払い戻しができなくなります",
        description1: "チケットを利用開始すると「",
        description2: "」の払い戻しができなくなります。使い始めますか？",
        buttonLabel1: "使い始める",
        buttonLabel2: "キャンセル",
      },
      validFreePass: {
        title: "チケットを利用します",
        description: "存分にお楽しみください。",
      },
      validPeriodPass: {
        title1: "",
        title2: "分以内にご利用ください",
        description1: "利用を開始してから",
        description2:
          "分経つと無効になります。まだ利用しない場合は「キャンセル」をタップしてください。",
        buttonLabel1: "利用する",
        buttonLabel2: "キャンセル",
      },
      QRSuccess: {
        title: "コードを認証しました",
        description: "チケット詳細画面を係員にご提示ください",
      },
      QRFailed: {
        title: "コードの認証ができませんでした",
        description:
          "チケット内容をご確認の上、再度QRコードの読み取りをお試しいただくか、救済コード入力画面を係員にお見せください。",
        buttonLabel1: "救済コード入力画面へ",
        buttonLabel2: "戻る",
      },
      passCodeFailed: {
        title: "救済コードの認証ができませんでした",
        description: "チケット内容をご確認の上、再度お試しください。",
      },
      couponCodeFailed: {
        title: "クーポンコードの認証ができませんでした",
        description: "再度お試しください。",
      },
      StampRally: {
        title: "スタンプ帳",
        confirm: "確認する",
        stamp: "スタンプを押す",
        use: "使う",
        open: "開く",
      },
    },
    Coupon: {
      couponCode: "クーポンコード",
      copy: "コピー",
      useCoupon: "このクーポンを使う",
      pastCoupon: "過去のクーポン",
      copiedCoupon: "クーポンコードをコピーしました",
      helpText:
        "※８桁もしくは16桁のクーポンコードをお持ちのお客様は、メニューボタンからクーポンコード入力へ進み、コードをご入力ください。",
    },
  },
};
